import * as React from 'react';
import { AppContext, AppProviderDispatch } from '../../../shared/app-context';
import MaterialIcon from '@material/react-material-icon';
import PublicEye from '../../../images/icons/public-eye';
import * as styles from '../report.module.scss';
import { CustomView } from './useCustomViews';
import { Scrollbars } from 'react-custom-scrollbars';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  customViews: CustomView[];
  activeCustomView?: any;
  showCustomView: (viewName?: string) => void;
}

const useStyles = makeStyles({
  buttonStyle: {
    paddingLeft: 0,
    border: 0,
    background: 'none'
  }
});

/**
 * Display the list of the current user's custom views
 */
const CustomViewList = ({ customViews, activeCustomView, showCustomView }: Props) => {
  const { state } = React.useContext<AppProviderDispatch>(AppContext);
  const classes = useStyles();

  return (
    <Scrollbars autoHide>
      {customViews.map((view) => {
        if (state.email.toLowerCase() === view.ownerEmail) {
          // Even if custom views exist, getActiveCustomView can be non-existent during loading
          const activeViewName = activeCustomView ? activeCustomView.getName() : '';
          const isActiveView = view.name === activeViewName;
          return (
            <button
              key={view.name}
              className={clsx(isActiveView ? styles.activeView : styles.viewName, classes.buttonStyle)}
              onClick={() => showCustomView(view.name)}
            >
              <span className={styles.myViewName}>
                {view.isDefault && <MaterialIcon title="Default" icon="insert_chart" />}
                <span>
                  {view.name}
                  {view.isDefault && ' (default)'}
                </span>
              </span>
              {view.isPublic && <PublicEye width="16" height="16" />}
            </button>
          );
        }
      })}
    </Scrollbars>
  );
};

export default CustomViewList;
